import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import { importLanguages, languageSelector } from "slices/languageSlice";
import { importLanguageTiers } from "slices/languageTierSlice";
import Api from "services/api";
import { useTranslation } from 'react-i18next';

const ImportLanguage = ({ show, onClose, callback, importType = "language" }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { error, loader } = useSelector((state) =>
    importType === "language-tier" ? state.languageTier : state.language
  );
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    if (!show) {
      setFile(null);
      setFileName("");
    }
  }, [show]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files?.[0];
    setFile(selectedFile || null);
    setFileName(selectedFile?.name || "");
  };

  const handleDownloadDemo = async () => {
    try {
      const response =
        importType === "language-tier"
          ? await Api.downloadLanguageTierImportDemoCsv()
          : await Api.downloadLanguageImportDemoCsv();

      if (response?.status >= 200 && response?.status < 300) {
        const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          importType === "language-tier" ? "language_tier_import_demo.csv" : "language_import_demo.csv"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        toast.error(response?.data?.message || "Could not download demo file.", {
          className: "errorToast",
        });
      }
    } catch (error) {
      toast.error(t('importLanguage.demoDownloadError'), {
        className: "errorToast",
      });
    }
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, { className: "successToast" });
      callback?.();
      onClose();
    } else {
      toast.error(message, { className: "errorToast" });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!file) {
      toast.error(t('importLanguage.fileRequired'), { className: "errorToast" });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    if (importType === "language-tier") {
      dispatch(importLanguageTiers(formData, submitCallback));
    } else {
      dispatch(importLanguages(formData, submitCallback));
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show" style={{ display: "block" }} role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content full_modal">
            <div className="modal-header header_modal align-items-center">
              <div></div>
              <h5 className="modal-title_u">
                {importType === "language-tier" ? t('importLanguage.titleTier') : t('importLanguage.titleLanguage')}
              </h5>
              <button onClick={onClose} type="button" className="btn-close" aria-label="Close"></button>
            </div>
            <div className="modal-body modal_form_body">
              <form onSubmit={handleSubmit}>
                <div className="row-primary">
                  <h2>{t('importLanguage.fileLabel')}</h2>
                  <input
                    type="file"
                    accept=".csv,text/csv"
                    className="input-in type_inp csv_file"
                    onChange={handleFileChange}
                  />
                  {/* {fileName && <p className="mt-2">Selected file: {fileName}</p>} */}
                </div>

                <div className="row-primary">
                  <button type="button" className="main_button" onClick={handleDownloadDemo}>
                    {t('importLanguage.demoButton')}
                  </button>
                  <div>
                    <h2 className="row-primary">
                      {t('importLanguage.demoText')}
                    </h2>
                  </div>
                </div>

                {error?.errors?.file?.map((message) => (
                  <div style={{ marginBottom: 10 }} key={message}>
                    <ErrorMessage text={message} />
                  </div>
                ))}

                <div className="Form-footer">
                  <button type="button" className="Cancle_button" onClick={onClose}>
                    {t('common.cancel')}
                  </button>
                  <SubmitButton btnText={t('common.import')} loader={loader} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ImportLanguage;
